module.exports = __webpack_public_path__ + "static/media/mp3.a5e85eda.svg";